
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { IRecipient } from '@/entities/notices'
import AvatarOrInitials from '@/components/WebView/AvatarOrInitials.vue'
import { UserDetail } from '@/entities'
import { decode as entityDecode } from 'he'
import Typography from '@/components/Rain/Typography/Typography.vue'

@Component<Recipient>({
    components: {
        Typography,
        AvatarOrInitials,
    },
    filters: {
        entityDecode,
    },
})
export default class Recipient extends Vue {
    @Prop() private recipient!: IRecipient
    @Prop({ type: Boolean, default: false }) private selected!: boolean
    // if compact, no border bottom, padding also smaller
    @Prop({ type: Boolean, default: false }) private compact!: boolean

    private get userForAvatar(): UserDetail {
        return {
            name: this.recipient.name,
            id: this.recipient.user_id,
            avatar: this.recipient.avatar,
        }
    }
}
